import { UserAccountType } from "../../../__generated__/types";
import { StepFormContainer } from "../../../components/step-form";
import { HdgRadioGroup } from "../../../components/hdg-radio-group";
import { useNavigate } from "react-router";
import { ButtonBase, Stack, Typography, Radio } from "@mui/material";
import designerImage from "../../../assets/general/user-type-designer.jpg";
import homeownerImage from "../../../assets/general/user-type-homeowner.jpg";
import classNames from "classnames";
import "./styles.scss";

const UserTypeSelection = ({
  title,
  description,
  selected,
  onClick,
  image,
  alt,
}: {
  title: string;
  description: string;
  selected: boolean;
  onClick: () => void;
  image: string;
  alt: string;
}) => {
  return (
    <ButtonBase
      className={classNames("user-type-selection", selected && "selected")}
      onClick={onClick}
    >
      <Stack direction="row" className="selection-container">
        <div className="image-container">
          <img src={image} alt={alt} />
        </div>
        <Stack justifyContent="center" className="text-container text-left">
          <div>
            <Typography variant="h6" className="title font-body" mb={"16px"}>
              {title}
            </Typography>
            <Typography variant="body1" className="description">
              {description}
            </Typography>
          </div>
        </Stack>
        <div className="radio-container">
          <Radio
            checked={selected}
            value={title}
            name="user-type-selection"
            inputProps={{ 'aria-label': title }}
            sx={{
              color: '#aaa',
              '&.Mui-checked': {
                color: '#4f46e5', // Purple color matching the SCSS variable
              },
            }}
          />
        </div>
      </Stack>
    </ButtonBase>
  );
};

export const UserTypeFieldset = ({
  isValid,
  step,
  setNextStep,
  setStep,
  setUserType,
  userType,
}: {
  isValid: boolean;
  step: number;
  setNextStep: () => void;
  setStep: (value: number) => void;
  setUserType: (value: UserAccountType) => void;
  userType?: UserAccountType;
}) => {
  const navigate = useNavigate();
  return (
    <StepFormContainer
      step={0}
      visible={step === 0}
      isValid={isValid}
      onSubmit={setNextStep}
      onBack={() => navigate("/login")}
    >
      <h1 className="margin-top-0 title font-title font-size-6">
        Let’s create your account
      </h1>
      <p className="description font-size-4">
        What brings you to Home Design Guild?
      </p>

      <Stack
        spacing={2}
        justifyContent={"start"}
        alignContent={"start"}
        className="user-type-selection-container"
      >
        <UserTypeSelection
          title="Designer"
          alt="Designer Application"
          onClick={() => setUserType(UserAccountType.Designer)}
          selected={userType === UserAccountType.Designer}
          description="Create stunning designs or find projects to showcase your expertise."
          image={designerImage}
        />

        <UserTypeSelection
          title="Homeowner"
          alt="Homewoner Application"
          onClick={() => setUserType(UserAccountType.Homeowner)}
          selected={userType === UserAccountType.Homeowner}
          description="Post your project and connect with the best designers."
          image={homeownerImage}
        />
      </Stack>
    </StepFormContainer>
  );
};
